import React from 'react'
import { BiMessageAltError } from 'react-icons/bi'
import { VscError } from 'react-icons/vsc'


const Error = ({message}) => {
    return (
        <div className="error">
            <VscError size="35"/>
            <div className="error__message">{message}</div>
        </div>
    );
}

export default Error;
